


// import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
// import bikeImage from "../assets/BikeImage1.png";
// import bikeImage1 from "../assets/BikeImage2.png";
// import bikeImage2 from "../assets/BikeImage3.png";
// import bikeImage3 from "../assets/BikeImage4.png";

// const Bikes = () => {
//     const bikeData = [
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
//         { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
//         { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
//         { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
//         { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
//         { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
//         { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
//         { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
//         { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
//         { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
//         // Add more bikes as needed
//     ];

//     const [formData] = useState(bikeData);
//     const navigate = useNavigate();

//     const handleBookNow = (bike) => {
//         // Navigate to the booking page with optional state
//         navigate("/filter-component", { state: { bike } });
//     };

//     return (
//         <div className="flex items-center justify-center p-4 md:p-14">
//             <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full">
//                 {formData.map((bike, index) => (
//                     <div key={index} className="relative border flex flex-col bg-white rounded-lg">
//                         <div className="flex-1 flex flex-col items-center mb-4 p-4">
//                             <div className="absolute top-2 left-2">
//                                 <select className="border rounded-md p-1 text-[#FF9630]">
//                                     <option>Duration</option>
//                                     <option value="1">1 month</option>
//                                     <option value="3">3 months</option>
//                                     <option value="6">6 months</option>
//                                 </select>
//                             </div>
//                             <h2 className="text-lg font-bold mt-8 text-center">{bike.name}</h2>
//                             <img
//                                 src={bike.imgSrc}
//                                 alt={bike.name}
//                                 className="w-full object-cover mt-4"
//                             />
//                             <p className="text-gray-600 mt-4 text-center">{bike.price}</p>
//                         </div>
//                         <div className="flex justify-center">
//                             <button
//                                 onClick={() => handleBookNow(bike)}
//                                 className="bg-[#FF9630] text-white py-2 w-full rounded-md"
//                             >
//                                 Book Now
//                             </button>
//                         </div>
//                     </div>
//                 ))}
//             </div>
//         </div>
//     );
// };

// export default Bikes;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import bikeImage from "../assets/BikeImage1.png";
import bikeImage1 from "../assets/BikeImage2.png";
import bikeImage2 from "../assets/BikeImage3.png";
import bikeImage3 from "../assets/BikeImage4.png";

const Bikes = () => {
    const bikeData = [
        { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
        { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
        { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
        { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
        { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
        { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
        { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
        { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
        { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage },
        { name: "Bajaj Pulsar NS200", price: "₹4200/month", imgSrc: bikeImage1 },
        { name: "TVS Apache RTR 160", price: "₹3500/month", imgSrc: bikeImage2 },
        { name: "Hero Glamour Xtec 125 N", price: "₹3702/month", imgSrc: bikeImage3 },
    ];

    const [formData] = useState(bikeData);
    const navigate = useNavigate();

    const handleBookNow = (bike) => {
         if (window.innerWidth <= 768) {
      // Redirect for mobile devices (<= 768px width)
      navigate("/filter-relevance");
    } else {
      // Optional: Handle other cases for larger screens
      navigate("/filter-component");
    }
    };

    return (
        <div className="flex items-center justify-center p-4 md:p-14">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 w-full">
                {formData.map((bike, index) => (
                    <div key={index} className="relative border flex flex-col bg-white rounded-lg">
                        <div className="flex-1 flex flex-col items-center mb-4 p-4">
                            <div className="absolute top-2 left-2">
                                <select className="border rounded-md p-1 text-[#FF9630]">
                                    <option>Duration</option>
                                    <option value="1">1 month</option>
                                    <option value="3">3 months</option>
                                    <option value="6">6 months</option>
                                </select>
                            </div>
                            <h2 className="text-lg font-bold mt-8 text-center">{bike.name}</h2>
                            <img
                                src={bike.imgSrc}
                                alt={bike.name}
                                className="w-full object-cover mt-4"
                            />
                            <p className="text-gray-600 mt-4 text-center">{bike.price}</p>
                        </div>
                        <div className="flex justify-center">
                            <button
                                onClick={() => handleBookNow(bike)}
                                className="bg-[#FF9630] text-white py-2 w-full rounded-md"
                            >
                                Book Now
                            </button>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default Bikes;
